import questionsTypes from '../../constants/questionsTypes'
export * from './create'
export * from './delete'
export * from './duplicate'
export * from './get'
export * from './get_audio'
export * from './get_image'
export * from './get_version_media'
export * from './getindex'
export * from './getcsv'
export * from './getxlsx'
export * from './publish'
export * from './trash'
export * from './unpublish'
export * from './update'
export * from './upload_audio'
export * from './upload_image'

const set_question_errors = (messages) => {
  return {
    type: questionsTypes.set_errors,
    payload: messages
  }
}

const reset_question = () => {
  return {
    type: questionsTypes.reset_question
  }
}

const clear_question = () => {
  return {
    type: questionsTypes.clear_question
  }
}

export {
  set_question_errors,
  reset_question,
  clear_question
}



// WEBPACK FOOTER //
// ./src/js/actions/questions/index.js